module.exports = __webpack_public_path__ + "img/Z60_16.c6bf8df0.jpg";